import {
  faArrowRightFromBracket,
  faBroadcastTower,
  faChartLine,
  faCircleChevronRight,
  faClipboardQuestion,
  faCommentAlt,
  faFile,
  faFilePen,
  faGear,
  faGraduationCap,
  faHouse,
  faQrcode,
  faStarHalfStroke,
  faUserGear,
  faUserMinus,
  faUserPlus,
  faUserShield,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useReducer } from "react";
import {
  Link,
  NavLink,
  Outlet,
  ScrollRestoration,
  useNavigate,
} from "react-router-dom";
import {
  useAuthDispatch,
  useAuthState,
} from "../../../MainComponents/GlobalContext";
import useAxios from "../../../MainComponents/Hooks/useAxios";
import { SiVodafone } from "react-icons/si";
import { MdLocalOffer, MdShield } from "react-icons/md";
import { RiUserFollowLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import { useMemo } from "react";
import axios from "axios";
import DarkModeToggle from "../../../MainComponents/DarkModeToggle";

function AdminLayout() {
  const AuthDispatch = useAuthDispatch();
  const AuthState = useAuthState();
  const navigate = useNavigate();
  const initialState = { collapse: false, showSidebar: false, refetch: false };
  function reducer(state, action) {
    switch (action.type) {
      case "SetCollapse": {
        return { ...state, collapse: !state.collapse };
      }
      case "SetRefetch": {
        return { ...state, refetch: !state.refetch };
      }
      case "SetShowSidebar": {
        return { ...state, showSidebar: action.payload };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);

  //!--------- get numbers in tabs-------
  const [NumbersInTabs, NumbersInTabsErrors] = useAxios(
    process.env.REACT_APP_ADMIN_NUMBERS_IN_TABS_API,
    "GET",
    "GET",
    state.refetch,
    "",
    "",
    AuthState.refetchIfAcceptOrDeleteRequest,
  );

  function handleSignOut() {
    dispatch({ type: "SetShowSidebar", payload: false });

    localStorage.removeItem("userData");
    AuthDispatch({ type: "setUserData", payload: null });
    navigate("/admin/signin");
  }

  const adminOrStuedntToken = JSON.parse(localStorage?.userData).admin_token
    ? JSON.parse(localStorage?.userData).admin_token
    : JSON.parse(localStorage?.userData).student_token;
  useMemo(() => {
    // set axios
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + adminOrStuedntToken;
  }, [adminOrStuedntToken]);

  return (
    <section className="flex h-screen max-h-screen w-full overflow-hidden bg-white text-slate-900 dark:bg-dark dark:text-light md:pt-16">
      <section className="header-mobile-only fixed inset-0 top-0 z-50  hidden h-16 w-full items-center justify-between bg-secondary px-16 text-white md:flex">
        <div className="logo h-fit">
          <img
            className="h-12 cursor-pointer transition duration-200 ease-in-out hover:scale-105"
            onClick={() => navigate("/admin/dashboard")}
            src="https://api.our-matrix.com/uploads/assets/logo.png"
            alt="logo-dash-bg"
          />
        </div>
        <div className="burger-dash bg">
          <input
            onChange={() =>
              dispatch({ type: "SetShowSidebar", payload: !state.showSidebar })
            }
            checked={state.showSidebar}
            type="checkbox"
            id="checkbox"
          />
          <label htmlFor="checkbox" className="toggle">
            <div className="bar bar--top"></div>
            <div className="bar bar--middle"></div>
            <div className="bar bar--bottom"></div>
          </label>
        </div>
      </section>

      {/**
       * //!dash menu fixed
       *
       */}
      <div
        className={`dash-menu-fixed admin-sidebar z-40 ${
          state.collapse ? "w-24 is-collapsed" : "w-1/5 "
        } fixed left-0 top-0 
                    h-full w-1/5 transition-all duration-200 ease-in-out ${
                      state.showSidebar
                        ? "md:pointer-events-auto md:w-full md:translate-x-0 md:opacity-100"
                        : "md:pointer-events-none  md:-translate-x-20 md:opacity-0"
                    } md:pt-32`}
      >
        <button
          type="button"
          aria-label="Collapse sidebar"
          onClick={() => dispatch({ type: "SetCollapse" })}
          className={`admin-sidebar__collapse ${
            state.collapse ? "is-collapsed" : ""
          }`}
        >
          <FontAwesomeIcon icon={faCircleChevronRight} />
        </button>
        <div className="admin-sidebar__inner dash-menu-container">
          <div className="admin-sidebar__header">
            <div
              className={`admin-sidebar__logo ${
                state.collapse ? "is-collapsed" : ""
              }`}
            >
              <img
                onClick={() => navigate("/admin/dashboard")}
                src="https://api.our-matrix.com/uploads/assets/logo.png"
                alt="logo-dash-bg"
              />
            </div>
            <div className="admin-sidebar__theme">
              <DarkModeToggle showLabel={false} />
            </div>
          </div>

          <ul className="admin-sidebar__nav dash-menu-items">
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.length > 0) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/dashboard"
                >
                  <div
                    className={`relative flex  w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faHouse} />
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Dashboard
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("student"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/students"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faUsers} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Students{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {/* 
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_add")
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_delete")
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_update")
              )) && (
              <li
                onClick={() =>
                  dispatch({
                    type: "SetRefetch",
                  })
                }
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({
                      type: "SetShowSidebar",
                      payload: false,
                    })
                  }
                  className="admin-dash-btn"
                  to="/admin/codes"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5 " icon={faQrcode} />{" "}
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Codes{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )} */}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_add"),
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_delete"),
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_update"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/points-codes"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5 " icon={faQrcode} />{" "}
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Points Codes
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {/* Vodafone Cash Permission */}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_addvodafone"),
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_update_vodafone"),
              ) ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("code_delete_vodafone"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/vodafone-cash-codes"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <SiVodafone />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Vodafone cash codes
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {/* Offers Code Permmison */}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("offer"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/offers-codes"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <MdLocalOffer />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Offers Codes
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("view_hold_codes"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/hold-codes"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <MdShield />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Hold Codes
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("tracker_hold_codes"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/hold-codes-tracker"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <MdShield />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Hold Codes Tracker
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {/* 
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("activation_code_view")
              )) && (
              <li
                onClick={() =>
                  dispatch({
                    type: "SetRefetch",
                  })
                }
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({
                      type: "SetShowSidebar",
                      payload: false,
                    })
                  }
                  className="admin-dash-btn"
                  to="/admin/activation-code "
                >
                  <div
                    className={`relative  flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5 " icon={faUserShield} />{" "}
                      <span
                        className={` ${state.collapse && "hidden"}  truncate `}
                      >
                        Activation Codes
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )} */}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("send_whatsapp"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/whatsapp"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <BsWhatsapp />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Whatsapp
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {AuthState.userData?.admin?.roles[0]?.name === "superadmin" && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/app-update"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon icon={faGear} />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        App Update
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("code_tracker"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/codes-tracker"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <RiUserFollowLine />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Codes Tracker
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("activation_code_tracker"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/activation-code-tracker"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <RiUserFollowLine />
                      <span
                        className={` 
                        ${state.collapse && "hidden"}   `}
                      >
                        Activation Code Tracker
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("lecture"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/courses"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faGraduationCap} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Courses{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("show_reports"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/reports"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faFile} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Reports
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("show_reports"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/late-students"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faUserMinus} />
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Late Students
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("exceptions"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/exception"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon
                        className="w-5"
                        icon={faBroadcastTower}
                      />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Exception
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("exam"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/exams"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faFilePen} />{" "}
                      <span
                        className={` ${state.collapse && "hidden"}  truncate `}
                      >
                        Trial Exams{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions.some((permission) =>
                permission.name.startsWith("questionbank"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/question-bank"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon
                        className="w-5"
                        icon={faClipboardQuestion}
                      />{" "}
                      <span
                        className={` ${state.collapse && "hidden"}  truncate `}
                      >
                        Question Bank
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("request"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/requests"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5 " icon={faUserPlus} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Requests{" "}
                      </span>
                    </div>
                    {NumbersInTabs?.data?.requests_count &&
                      (AuthState.userData?.admin?.roles[0]?.name ===
                        "superadmin" ||
                        AuthState.userData?.admin?.permissions?.some(
                          (permission) =>
                            permission.name.startsWith("request_accept"),
                        )) && (
                        <>
                          <span
                            className={`numbers rounded-full bg-red-400 px-1 text-sm lg:hidden amd-dash:block ${
                              state.collapse && "hidden"
                            }`}
                          >
                            {NumbersInTabs?.data?.requests_count}
                          </span>
                          <div
                            className={`notification-pointer x absolute bottom-1/2 right-[5px] h-2 w-2 translate-y-1/2 rounded-full bg-red-400 lg:block amd-dash:-right-3 amd-dash:top-0 amd-dash:translate-y-0 amd-dash:hidden ${
                              state.collapse
                                ? " -right-[11px] top-0 block translate-y-0 "
                                : "hidden"
                            } `}
                          ></div>
                        </>
                      )}
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("user"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/assistants"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faUserGear} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Assistants{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("reviews"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/reviews"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon
                        className="w-5"
                        icon={faStarHalfStroke}
                      />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Reviews{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
            {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
              AuthState.userData?.admin?.permissions?.some((permission) =>
                permission.name.startsWith("analystics"),
              )) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/analytics"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faChartLine} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Analytics{" "}
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {AuthState.userData?.admin?.permissions?.some((permission) =>
              permission.name.startsWith("ask"),
            ) && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/chat"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faCommentAlt} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        Inbox
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}

            {AuthState.userData?.admin?.roles[0]?.name === "superadmin" && (
              <li
                onClick={() => dispatch({ type: "SetRefetch" })}
                className="w-full"
              >
                <NavLink
                  onClick={() =>
                    dispatch({ type: "SetShowSidebar", payload: false })
                  }
                  className="admin-dash-btn"
                  to="/admin/all-chats"
                >
                  <div
                    className={`relative flex w-[212px]  items-center   justify-between gap-4  ${
                      state.collapse && "w-fit"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-4 alg:gap-2">
                      <FontAwesomeIcon className="w-5" icon={faCommentAlt} />{" "}
                      <span className={` ${state.collapse && "hidden"}   `}>
                        All Chats
                      </span>
                    </div>
                  </div>
                </NavLink>
              </li>
            )}
          </ul>

          <div className="admin-sidebar__footer">
            <NavLink
              to="/admin/profile"
              onClick={() =>
                dispatch({ type: "SetShowSidebar", payload: false })
              }
              className={({ isActive }) =>
                `admin-sidebar__user ${isActive ? "is-active" : ""} ${
                  state.collapse ? "is-collapsed" : ""
                }`
              }
            >
              <div className="admin-sidebar__user-avatar">
                <img
                  src={`https://api.our-matrix.com/uploads/profile_picture/${AuthState.userData?.admin?.profile_pic}`}
                  alt={AuthState.userData?.admin?.name || "Admin"}
                />
              </div>
              {!state.collapse && (
                <div className="admin-sidebar__user-meta">
                  <span className="admin-sidebar__user-name">
                    {AuthState.userData?.admin?.name || "Admin"}
                  </span>
                </div>
              )}
            </NavLink>

            <div
              className="admin-dash-btn admin-sidebar__logout cursor-pointer"
              onClick={() => handleSignOut()}
            >
              <div
                className={`relative flex w-[212px]  items-center   justify-between gap-4 ${
                  state.collapse && "w-fit"
                }`}
              >
                <div className="flex items-center justify-start gap-4 alg:gap-2">
                  <FontAwesomeIcon
                    className="w-5"
                    icon={faArrowRightFromBracket}
                  />{" "}
                  <span className={` ${state.collapse && "hidden"}   `}>
                    Logout{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/**
       * //!placeholder
       *
       */}
      <div
        className={`placeholder h-full ${
          state.collapse ? "w-24" : "w-1/5 min-w-[20%]"
        }  transition-all duration-200 ease-in-out md:w-0 md:min-w-[0%]`}
      ></div>
      {/**
       * //!outlet
       *
       */}
      <section className="outlet  h-full w-full overflow-y-auto  ">
        <Outlet dispatch="dddd" />
        <ScrollRestoration />
      </section>
    </section>
  );
}

export default AdminLayout;
